module.exports = __webpack_public_path__ + "static/media/logo-sg.c40e9529.png";